var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div>By checking this box, you agree to receive recurring automated promotional and personalized marketing text messages (e.g. cart reminders) from Mud Pie at the cell number used when signing up. Consent is not a condition of any purchase. Reply HELP for help and STOP to cancel. Msg frequency varies. Msg & data rates may apply. <a href=\"https://attnl.tv/t/QLp\" target=\"_blank\">View Privacy Terms</a></div>";
var id1="email-subscribe-prompt.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;